import { ProductVariantMetafield, ProductVariantSettingsMetafield, OptionValueMetaField, ProductSettingsMetafield, ProductOptionMetafield, ProductOptionValueMetafield, OptionMetaField } from '@pa/common'

export class ProductSelector {
  _product?: ProductSettingsMetafield;
  _productOptionValues?: {[optionValueId: number]: ProductOptionValueMetafield }
  _options?: {[optionId:number]: OptionMetaField };
  _optionValues?: {[optionValueId:number]: OptionValueMetaField & { option_id: number } };
  _shopifyVariants?: { [shopifyVariantId: number]: ShopifyVariant };
  _variants?: { [shopifyVariantId: number]: ProductVariantMetafield };
  _variantOptionValues: Map<number,Set<number>>;
  _selectedOptionValues: { [optionId:number]: number | undefined } = {};


 
  get options(){
    if(this._options) return this._options;
    this._options = (window as any).QCM_OPTIONS;
    if(! this._options ) {
      throw new Error("Unable to parse options data");
    }
    return this._options;
  }

  get optionValues(){
    if(this._optionValues) return this._optionValues;
    const options = this.options;
    
    let optionValues = {};
    Object.values(options).forEach((option) => {
    const currentOptionValues = (window as any)[`QCM_OPTION_${option.id}_VALUES`] as {[optionValueId:number]: OptionValueMetaField } ;
      if(!currentOptionValues){
        console.warn(`Unable to find option values for option ${option.id}.`)
        return
      }
      optionValues = Object.values(currentOptionValues).reduce((agg, current) => {
        agg[current.id] = {...current, option_id: option.id };
        return agg;
      }, optionValues)
    })
    this._optionValues = optionValues;
    return this._optionValues;
  }

  get product(){
    if(this._product) return this._product;
    this._product = (window as any).QCM_PRODUCT;
    if(!this._product){
      throw new Error('Unable to parse product data')
    }
    return this._product;
  }

  get productOptionValues(){
    if(this._productOptionValues) return this._productOptionValues;
    const product = this.product;
    
    let productOptionValues = {};
    Object.values(product.options_applied).forEach((po) => {
      po.product_option_values.forEach((pov) => {
        productOptionValues[pov.id] = pov;
      })
    })
    this._productOptionValues = productOptionValues;
    return this._productOptionValues;
  }

  get variants(){
    if(this._variants) return this._variants
    const variantsData = (window as any).QCM_VARIANTS as ProductVariantSettingsMetafield;
    if(!variantsData){
      throw new Error('Unable to parse variant data')
    }
    
    this._variants = Object.values(variantsData.values).reduce((agg, v) => {
      if(v.sv_id) {
        agg[v.sv_id] = v;
      };
      return agg;
    }, {});

    return this._variants;
  }


  get shopifyVariants(){
    if(this._shopifyVariants) return this._shopifyVariants
    const shopifyVariants = (window as any).QCM_COMBINED_VARIANTS as ShopifyVariant[];
    this._shopifyVariants = shopifyVariants.reduce((agg,variant) => {
      if(
        ["default title", "default value"].includes(variant.title.toLowerCase()) ||
        !variant.available
      ) {
        return agg;
      }

      agg[variant.id] = variant;
      return agg;
    }, {})
    return this._shopifyVariants;
  }

  getVariant(){    
    const selectedOptionValues = Object.values(this._selectedOptionValues).filter(Boolean) as number[];
    if(selectedOptionValues.length === Object.keys(this.options)?.length){
      const viableVariants = this.viableVariants(selectedOptionValues, true)      
      return (viableVariants && viableVariants[0]) ?? undefined;
    }else{
      const viableVariants = this.viableVariants(selectedOptionValues)
    }
    return false;
  }

  filterImages(){    
    console.log(`filter on init`);
    const selectedOptionValues = Object.values(this._selectedOptionValues).filter(Boolean) as number[];
    let viableVariants;

    const ovArray = Object.values(this.optionValues);
    const orderedOptionValues = ovArray.sort((a, b) => {
      if(!a.order || !b.order){
        return -1;
      }
      if (a?.order < b?.order) {
        return -1;
      }
      if (b.order > a.order) {
        return 1;
      }
      return 0;      
    });

    const images = document.querySelectorAll(".product__media-item-filterable");
  
    for(const image of images){
      image.classList.add("visually-hidden");
    } 

    //if all of our options have been selected, we know exactly what images to show
    if(selectedOptionValues.length === Object.keys(this.options)?.length){      
      viableVariants = this.viableVariants(selectedOptionValues, true)

      if(viableVariants.length < 1){
        images[0].classList.remove("visually-hidden");
        return;
      }   
          
      const viableVariantImages = document.querySelectorAll(`.product__media-item-filterable[data-variant="${viableVariants[0].id}"]`);
  
      if(!viableVariantImages){
        images[0].classList.remove("visually-hidden");
        return;
      }
  
      for(const image of viableVariantImages){
        image.classList.remove("visually-hidden");
      }

    }else{
      let variantMatched = false;
      //this will return all variants in the case that no option has been selected yet.
      viableVariants = this.viableVariants(selectedOptionValues);
                        
      //find ov for selectedOptionValues
      for(const ov of selectedOptionValues){
        for(const k in this.productOptionValues){
          const pov = this.productOptionValues[k];              
          if(pov.option_value_id === ov){
            const optionValueImages: any = document.querySelectorAll(`.product__media-item-filterable[data-option-value-id="${pov.id}"]`);
            if(optionValueImages.length < 1){
              continue;
            }

            const firstVariantID = optionValueImages[0].dataset.variant;
            const variantSpecificImages = document.querySelectorAll(`.product__media-item-filterable[data-variant="${firstVariantID}"]`);
  
            for(const image of variantSpecificImages){
              image.classList.remove("visually-hidden");     
              variantMatched = true;            
            } 
            
            break;            
          }
        }
        if(variantMatched === true){
          break;
        }
      }

      if(variantMatched === false){        
        //in this case, we haven't matched an exact variant, and we don't have a set of images for a partially matched variant.
        //just show the first available images for an in stock variant
        if((window as any).QCM_SELECTED_VARIANT){
          const variantSpecificImages = document.querySelectorAll(`.product__media-item-filterable[data-variant="${(window as any).QCM_SELECTED_VARIANT}"]`);

          for(const image of variantSpecificImages){
            image.classList.remove("visually-hidden");             
          }   
          return;
        }

        let matchingOptionValueIdsFromVariants: any = [];
        let selectedProductOptionValues: number[] = [];
        for(const op of selectedOptionValues){
          for(const k in this.productOptionValues){
            if(this.productOptionValues[k].option_value_id === op){
              selectedProductOptionValues.push(this.productOptionValues[k].id)
            }
          }  
        }

        for(const v in this.variants){
          const variant = this.variants[v];          
          for(const op of selectedProductOptionValues){            
            if(variant.ov.includes(op)){              
              matchingOptionValueIdsFromVariants.push(...variant.ov)
            }
          }
        }

        const setOfCompatibleOptionValueIds = this.compatibleOptionValues(selectedOptionValues);        
        for(const ov of orderedOptionValues){
          let pov;
          
          for(const k in this.productOptionValues){
            if(this.productOptionValues[k].option_value_id === ov.id){
              pov = this.productOptionValues[k];
            }
          }
  
          if(!pov) continue; 

          if(selectedOptionValues.length > 0 && !matchingOptionValueIdsFromVariants.includes(pov.id)) continue;
          
          const optionValueImages: any = document.querySelectorAll(`.product__media-item-filterable[data-option-value-id="${pov.id}"]`) as any;
          if(optionValueImages.length < 1){
            continue;
          }
          
          const firstVariantID = optionValueImages[0].dataset.variant;
          const variantSpecificImages = document.querySelectorAll(`.product__media-item-filterable[data-variant="${firstVariantID}"]`);

          for(const image of variantSpecificImages){
            image.classList.remove("visually-hidden");             
          }   

          break;
        }
      }
    }    
  }

  viableVariants(selectedOptionValueIds: number[], exactMatch=false){    
    const selectedOptionValueSet = new Set<number>(selectedOptionValueIds);

    if (selectedOptionValueSet.size === 0) {
      return Object.values(this.shopifyVariants);
    }

    const foundVariants =
      Object.values(this.variants).filter((v) => {
        const optionValuesNeeded = new Set<number>(
          selectedOptionValueSet.values()
        );
        v.ov.forEach(povId => {
          const ovId = this.productOptionValues[povId].option_value_id;
          if (selectedOptionValueSet.has(ovId)) {
            optionValuesNeeded.delete(ovId);
          }
        });

        if (
          (!exactMatch && optionValuesNeeded.size < selectedOptionValueSet.size) ||
          (exactMatch && optionValuesNeeded.size === 0) 
        ){
          return true;
        }

        return false;
      })
      .map(v => {
        if(!v.sv_id) return undefined;
        const shopifyVariant = this.shopifyVariants[v.sv_id]
        return shopifyVariant;
      })
      .filter(sv => {
        if(!sv) return false;
        return sv.available
      }) as ShopifyVariant[]

      return foundVariants;
  }

  compatibleOptionValues(selectedOptionValueIds: number[]){    
    const shopifyVariants = this.viableVariants(selectedOptionValueIds);
    const optionValueIds = new Set<number>();
    shopifyVariants.forEach(sv => {
      const variant = this.variants[sv.id];
      if(!variant){
        console.warn(`Unable to find variant for id ${sv.id}.`)
        return
      }
      variant.ov.forEach(povId => {
        const ovId = this.productOptionValues[povId]?.option_value_id;
        if(!ovId){
          console.warn(`Unable to find option value from product option value id ${povId}`)
          return;
        }
        optionValueIds.add(ovId)
      })
    })
    return optionValueIds
  }

  
  getSelectionFromVariant = (shopifyVariantId: number) => {    
    if(!shopifyVariantId){
      return Object.values(this.options).reduce((agg, x) => {
        agg[x.id] = undefined;
        return agg;
      }, {})
    }
    const variant = this.variants[shopifyVariantId];
    const selectedOptionValues: {[optionId: number]: number} = {};
    variant.ov.forEach(povId => {
      const ovId = this.productOptionValues[povId]?.option_value_id;
      if(!ovId){
        console.warn(`Unable to find option value from product option value id ${povId}`)
        return;
      }
      const optionValue = this.optionValues[ovId];
      selectedOptionValues[optionValue.option_id] = ovId
    });
    return selectedOptionValues;
  }

  filter = (fieldsets:HTMLFieldSetElement[]) => {
    
    fieldsets.forEach((fieldset) => {
      const fieldSetInputs = Array.from(fieldset.querySelectorAll('input'));
      const optionId = Number.parseInt(fieldset.dataset?.optionId ?? 'NaN');
      const selectedOptionValue = fieldSetInputs.find((radio) => radio.checked);
      const productOptionValueId = Number.parseInt(selectedOptionValue?.value ?? 'NaN');
      const optionValueId = this.productOptionValues[productOptionValueId]?.option_value_id;
      if(!Number.isInteger(optionId)){
        throw new Error(`Unable to parse option ID from ${optionId}`);
      }
      if(!Number.isInteger(optionValueId)) {
        delete this._selectedOptionValues[optionId]; 
      } else {
        this._selectedOptionValues[optionId] = optionValueId;
      }
    })

    fieldsets.forEach((fieldset) => {
      const fieldSetInputs = Array.from(fieldset.querySelectorAll('input'));
      const optionId = Number.parseInt(fieldset.dataset?.optionId ?? 'NaN');
      const selectedOptionValue = fieldSetInputs.find((radio) => radio.checked);
      if(!Number.isInteger(optionId)){
        throw new Error(`Unable to parse option ID from ${optionId} - (B)`);
      }
   

      let selectedOptionsNotIncludingCurrentOption = {...this._selectedOptionValues };
      const selectedNumber = Object.keys(this._selectedOptionValues).length;
      if ( fieldsets.length === 1 || (selectedNumber > 0 && (selectedNumber < fieldsets.length))){ 
        delete selectedOptionsNotIncludingCurrentOption[optionId];
      }
  
      const selectedOptionValueIdsNotIncludingCurrentOption = Object.values(selectedOptionsNotIncludingCurrentOption).filter(Boolean) as number[];

      const setOfCompatibleOptionValueIds = this.compatibleOptionValues(selectedOptionValueIdsNotIncludingCurrentOption);


      [...fieldSetInputs].forEach((inputEle) => {
        let povId = parseInt(inputEle.value);
        if(!Number.isInteger(povId)){
          throw new Error(`Unable to parse product option ID from ${povId}`);
        }
        
        const ovId = this.productOptionValues[povId]?.option_value_id;
        const isSelected = inputEle.value === selectedOptionValue?.value;
        const isCompatible = setOfCompatibleOptionValueIds.has(ovId)

        if(isSelected || isCompatible){
          inputEle.disabled = false;
        } else {
          inputEle.disabled = true;
        }

        if(isSelected){
          inputEle.checked = true;
        } else {
          inputEle.checked = false;
        }
        
      });

      this.filterImages();
    });
  }

  reset(){
    this._selectedOptionValues = {};
  }

  canAddToCart(){
    const selectedVariant = this.getVariant();
    return selectedVariant;
  }

}

export interface ShopifyVariant {
  available: boolean;
  barcode: string;
  compare_at_price: number | null;
  // featured_image: null
  id: number;
  inventory_management: string;
  name: string;
  option1: string | null;
  option2: string | null;
  option3: string | null;
  options: string[];
  price: number;
  public_title: string;
  requires_selling_plan: boolean;
  requires_shipping: boolean;
  // selling_plan_allocations: []
  sku: string;
  taxable: boolean;
  title: string;
  weight: number;
}